import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { YSButton } from "../../../uikit/YSButton";
import { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import {
  greyColor,
  InputSMBoxStyle,
  BtnSMGroupStyle,
  LabelSMBoxStyle,
  HtmlTooltip,
  ContentStyle,
  DRxSelectStyle,
  DRxInputStyle,
} from "../../../Theme";
import { useLocation, useNavigate } from "react-router";
import InfoIcon from "../../../images/icons/InfoIcon.svg";
import { HelpGuideTooltip } from "../../../components/HelpGuideTooltip";
import DRxInput from "../../../uikit/DRxInput";
import { DRxSelect2 } from "../../../uikit/DRxSelect2";
import { RxFillAlertsDetails } from "../../../Apis/AuthApiServices";
import { PatientInfoCard } from "../../../components/Content";
import { useSelector } from "react-redux";
import { DialogPopup } from "../../../components/DialogPopup";
import DrugNotMatchPopUp from "../../../components/DrugNotMatchPopUp";
import PatientNotMatchPopUp from "../../../components/PatientNotMatchPopUp";

const initialStateRxFillAlertReview = {
  name: "",
  age: "",
  patientId: "",
  telePhone: "",
  ssn: "",
  dateOfBirth: "",
  gender: "",
  address: "",
  writtenDate: "",
  rxFillStatus: "",
  dispensedLastFilledDate: "",
  drugDescription: "",
  sig: "",
  daysSupply: "",
  qtyQualifier: "",
  quantity: "",
  dispensedQuantity: null,
  pharmacyNote: "",
  notes: "",
  pharmacyName: "",
  messageId: "",
  workPhone: "",
  nightPhone: "",
  fileId: "",
  status: "",
  matchingPatientFoundFlag: "",
  matchingDrugFoundFlag: "",
  searchPatientName: "",
  createdDate: "",
  prescriberOrderNumber: "",
  matchingName: "",
  origRequestWrittenDate: "",
  validatedPON: "",
  patientSelected: null,
  ponValidated: null,
  dispensibleDrugId: null,
  messageAfterDrugSelection: "",
  rawSSMessageId: "",
  matchingDrugName: "",
  pageSize: null,
  refillRequested: null,
  lastFilledDate: "",
  doctorId: "",
  doctorLastName: "",
  doctorFirstName: "",
  strength: "",
  strengthUnit: "",
  refills: null,
  patientAddressLine1: null,
  patientAddressLine2: null,
  city: " ",
  state: "",
  zip: "",
  substitutionCode: "",
  substitutionCodeOptions: [],
  substitutions: "",
  patientLastName: "",
  patientFirstName: "",
  dispensedDrugId: "",
  dispensedDrugDescription: "",
  dispensedQualifier: "",
  dispensedRefills: null,
  dispensedNotes: "",
  pharmacyId: "",
  pharmacyType: "",
  pharmacyAddressLine1: "",
  pharmacyAddressLine2: "",
  pharmacyLandMark: "",
  pharmacyTwentyFourHourFlag: "",
  pharmacyStoreNumber: "",
  pharmacyCity: "",
  pharmacyState: "",
  pharmacyZip: "",
  pharmacyPhoneNumber: "",
  pharmacyFaxNumber: "",
  patientAllergyList: [],
  allergyListSize: "",
  dispensedSubstitution: "",
  dispensedDirections: "",
  dispensedWrittenDate: "",
  deaClassCode: "",
  dosageForm: "",
};

export default function RxFillAlertReview() {
  const [ReviewData, setReviewData] = useState<any>(
    initialStateRxFillAlertReview
  );
  const [loader, setLoader] = useState(false);
  const location: any = useLocation();
  const history = useNavigate();
  const [DrugNotMatchPopup, setDrugNotMatchPopup] = useState(false);
  const handleShowDrugNotMatchPopupClick = () => {
    setDrugNotMatchPopup(true);
  };
  const handleHideDrugNotMatchPopupClick = () => {
    setDrugNotMatchPopup(false);
  };
  const [PatientNotMatchPopup, setPatientNotMatchPopup] = useState(false);
  const handleShowPatientNotMatchPopupClick = () => {
    setPatientNotMatchPopup(true);
  };
  const handleHidePatientNotMatchPopupClick = () => {
    setPatientNotMatchPopup(false);
  };
  const handleBackClick = () => {
    history("/rxfillalert");
  };

  const AllDropdwonsState = useSelector((state: any) => {
    return { ...state.GlobalDropdownSlice.DropdownLists };
  }); //redux data

  const getRxFillAlertsDetails = async () => {
    try {
      setLoader(true);
      const params = new URLSearchParams();
      params.append("doctorId", location?.state?.rowData?.doctorId);
      params.append("messageId", location?.state?.rowData?.messageId);
      const result = await RxFillAlertsDetails(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        if (result?.data?.response[0]?.patientMismatchPopupFlag) {
          handleShowPatientNotMatchPopupClick();
        } else if (result?.data?.response[0]?.drugMismatchPopupFlag) {
          handleShowDrugNotMatchPopupClick();
        }
        setReviewData(result?.data?.response[0]);
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
    }
  };
  useEffect(() => {
    getRxFillAlertsDetails();
  }, []);

  // useEffect(() => {
  //   if (ReviewData?.patientMismatchPopupFlag) {
  //     handleShowPatientNotMatchPopupClick();
  //   } else if (ReviewData?.drugMismatchPopupFlag) {
  //     handleShowDrugNotMatchPopupClick();
  //   }
  // }, [ReviewData]);
  return (
    <>
      <ContentStyle>
        <Typography
          className="help"
          component="h6"
          color="primary"
          variant="h6"
        >
          Rx Fill Alerts{" "}
          <HelpGuideTooltip
            content={
              <>
                {" "}
                <Typography component="div" variant="body1">
                  Rxfill related data discrepancies or patient level mismatches
                </Typography>
              </>
            }
          />
        </Typography>
        {loader ? (
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            height={"100vh"}
          >
            <CircularProgress color="primary" />
          </Grid>
        ) : (
          <>
            <Formik
              initialValues={ReviewData}
              enableReinitialize={true}
              onSubmit={(values) => {
                console.log(values);
              }}
            >
              {(registerProps) => (
                <Form onSubmit={registerProps.handleSubmit}>
                  <PatientInfoCard
                    name={
                      // matchingList
                      //   ? ReviewData?.matchingPatientsList[0]?.name
                      //   :
                      ReviewData?.name
                    }
                    patientId={
                      // matchingList
                      //   ? ReviewData?.matchingPatientsList[0]?.personId
                      //   :
                      ReviewData?.patientId
                    }
                    age={
                      // matchingList
                      //   ? ReviewData?.matchingPatientsList[0]?.age
                      //   :
                      ReviewData?.age
                    }
                    telePhone={
                      // matchingList
                      //   ? ReviewData?.matchingPatientsList[0]?.homeTelephone
                      //   :
                      ReviewData?.telePhone
                    }
                    address={
                      // matchingList
                      //   ? ReviewData?.matchingPatientsList[0]?.address
                      //   :
                      ReviewData?.address
                    }
                    ssn={
                      // matchingList
                      //   ? ReviewData?.matchingPatientsList[0]?.ssn
                      //   :
                      ReviewData?.ssn
                    }
                    dateOfBirth={
                      // matchingList
                      //   ? ReviewData?.matchingPatientsList[0]?.dateOfBirth
                      //   :
                      ReviewData?.dateOfBirth
                    }
                    gender={
                      // matchingList
                      //   ? ReviewData?.matchingPatientsList[0]?.gender
                      //   :
                      ReviewData?.gender
                    }
                  />
                  <Grid
                    container
                    item
                    xs={12}
                    spacing={0}
                    alignItems="top"
                    justifyContent="space-between"
                    columnSpacing={5}
                  >
                    <Grid item xs={12} md={6}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          color={greyColor}
                          variant="body2"
                          htmlFor="written_date"
                        >
                          Written Date
                        </Typography>{" "}
                        <Box>
                          <DRxInputStyle>
                            <DRxInput
                              id="written_date"
                              name="writtenDate"
                              className=""
                              disabled={true}
                              value={registerProps.values.writtenDate}
                            />
                          </DRxInputStyle>
                        </Box>
                      </InputSMBoxStyle>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          color={greyColor}
                          variant="body2"
                          htmlFor="dispensings"
                          marginTop={"0 !important"}
                        >
                          Total number of dispensings approved{" "}
                        </Typography>{" "}
                        <Box>
                          <DRxInputStyle>
                            <DRxInput
                              id="dispensings"
                              name="refills"
                              className=""
                              disabled={true}
                              value={registerProps.values.refills}
                            />
                          </DRxInputStyle>
                        </Box>
                      </InputSMBoxStyle>
                    </Grid>{" "}
                    <Grid item xs={12} md={6}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          color={greyColor}
                          variant="body2"
                          htmlFor="drugdescription"
                        >
                          Drug Description
                        </Typography>{" "}
                        <Box display={{ xs: "flex", sm: "flex", md: "flex" }}>
                          <DRxInputStyle>
                            <DRxInput
                              id="drugdescription"
                              name="drugDescription"
                              className=""
                              disabled={true}
                              value={registerProps.values.drugDescription}
                            />
                          </DRxInputStyle>
                          <HtmlTooltip
                            placement="right"
                            arrow
                            title={<DispensedDrugInfo row={ReviewData} />}
                          >
                            <IconButton className="tooltip">
                              <img
                                src={InfoIcon}
                                alt="Tooltip"
                                loading="lazy"
                              />
                            </IconButton>
                          </HtmlTooltip>
                        </Box>{" "}
                      </InputSMBoxStyle>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          color={greyColor}
                          variant="body2"
                          htmlFor="SIG"
                        >
                          SIG
                        </Typography>{" "}
                        <Box>
                          <DRxInputStyle>
                            <DRxInput
                              id="SIG"
                              name="sig"
                              className=""
                              disabled={true}
                              value={registerProps.values.sig}
                            />
                          </DRxInputStyle>
                        </Box>
                      </InputSMBoxStyle>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          color={greyColor}
                          variant="body2"
                          htmlFor="DaysSupply"
                        >
                          Days Supply{" "}
                        </Typography>{" "}
                        <Box>
                          <DRxInputStyle>
                            <DRxInput
                              id="DaysSupply"
                              name="daysSupply"
                              className=""
                              disabled={true}
                              value={registerProps.values.daysSupply}
                            />
                          </DRxInputStyle>
                        </Box>
                      </InputSMBoxStyle>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          color={greyColor}
                          variant="body2"
                          htmlFor="Qualifier"
                        >
                          Qualifier{" "}
                        </Typography>{" "}
                        <Box>
                          <DRxInputStyle>
                            <DRxInput
                              id="Qualifier"
                              name="qtyQualifier"
                              className=""
                              disabled={true}
                              value={registerProps.values.qtyQualifier}
                            />
                          </DRxInputStyle>
                        </Box>
                      </InputSMBoxStyle>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          color={greyColor}
                          variant="body2"
                          htmlFor="Quantity"
                        >
                          Quantity{" "}
                        </Typography>{" "}
                        <Box>
                          <DRxInputStyle>
                            <DRxInput
                              id="Quantity"
                              name="quantity"
                              className=""
                              disabled={true}
                              value={registerProps.values.quantity}
                            />
                          </DRxInputStyle>
                        </Box>
                      </InputSMBoxStyle>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          color={greyColor}
                          variant="body2"
                          htmlFor="NoteFromPharmacy"
                          marginTop={"0 !important"}
                        >
                          Note From Pharmacy{" "}
                        </Typography>{" "}
                        <Box>
                          <DRxInputStyle>
                            <DRxInput
                              id="NoteFromPharmacy"
                              name="pharmacyNote"
                              className=""
                              disabled={true}
                              value={registerProps.values.pharmacyNote}
                              onChange={registerProps.handleChange}
                            />
                          </DRxInputStyle>
                        </Box>
                      </InputSMBoxStyle>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          color={greyColor}
                          variant="body2"
                          htmlFor="note"
                        >
                          Note
                        </Typography>{" "}
                        <Box>
                          <DRxInputStyle>
                            <DRxInput
                              id="note"
                              name="notes"
                              className=""
                              value={registerProps.values.notes}
                            />
                          </DRxInputStyle>
                        </Box>
                      </InputSMBoxStyle>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <InputSMBoxStyle>
                        <Typography
                          component="label"
                          color={greyColor}
                          variant="body2"
                          htmlFor="substitution"
                        >
                          Substitutions
                        </Typography>
                        <Box>
                          <DRxSelectStyle>
                            <DRxSelect2
                              name="substitutionCode"
                              id="substitution"
                              disabled={true}
                              options={
                                AllDropdwonsState?.substitutionCodeOptions ?? [
                                  { value: "", label: "" },
                                ]
                              }
                              onChange={(option: any, e: any) => {
                                registerProps.setFieldValue(
                                  "substitutionCode",
                                  e.props.value
                                );
                              }}
                              value={registerProps.values.substitutionCode}
                            />
                          </DRxSelectStyle>
                        </Box>
                      </InputSMBoxStyle>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <LabelSMBoxStyle>
                        <Typography
                          component="label"
                          color={greyColor}
                          variant="body2"
                        >
                          RxFill Type
                        </Typography>
                        <Box>
                          <DRxInput
                            id="sig"
                            name="rxFillStatus"
                            type="text"
                            className=""
                            disabled={true}
                          />
                        </Box>
                      </LabelSMBoxStyle>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <LabelSMBoxStyle>
                        <Typography
                          component="label"
                          color={greyColor}
                          variant="body2"
                        >
                          Pharmacy
                        </Typography>
                        <Box>
                          <Typography
                            component="div"
                            marginTop={1}
                            color="primary"
                            variant="body2"
                          >
                            {ReviewData?.pharmacyName}
                            <HtmlTooltip
                              placement="right"
                              arrow
                              title={<PharmacyDetails row={ReviewData} />}
                              className="w316"
                            >
                              <IconButton className="tooltip">
                                <img
                                  src={InfoIcon}
                                  alt="Tooltip"
                                  loading="lazy"
                                />
                              </IconButton>
                            </HtmlTooltip>
                          </Typography>
                        </Box>
                      </LabelSMBoxStyle>
                    </Grid>
                    <Grid item xs={12}>
                      <BtnSMGroupStyle>
                        <YSButton
                          className={""}
                          children={"Back"}
                          onClick={handleBackClick}
                          variant={"outlined"}
                          type={"button"}
                          size={"large"}
                          color="secondary"
                        />
                      </BtnSMGroupStyle>
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          </>
        )}
      </ContentStyle>
      <DialogPopup
        title="Prescribed matching medication 	"
        windowsize={"sm"}
        show={DrugNotMatchPopup}
        handleShowPopupClick={handleShowDrugNotMatchPopupClick}
        handleHidePopupClick={handleHideDrugNotMatchPopupClick}
      >
        <DrugNotMatchPopUp matchingDrugList={ReviewData?.matchingDrugList} />
      </DialogPopup>
      <DialogPopup
        title="Patient Selection"
        windowsize={"md"}
        show={PatientNotMatchPopup}
        handleShowPopupClick={handleShowPatientNotMatchPopupClick}
        handleHidePopupClick={handleHidePatientNotMatchPopupClick}
      >
        <PatientNotMatchPopUp
          RequestData={ReviewData}
          setReviewData={setReviewData}
          handleHidePatientNotMatchPopupClick={
            handleHidePatientNotMatchPopupClick
          }
        />
      </DialogPopup>
    </>
  );
}
const DispensedDrugInfo = (props: any) => {
  const { row } = props;
  return (
    <>
      <Typography component={"div"} variant={"h6"} fontWeight={700}>
        Medication Dispensed
      </Typography>

      <Grid container rowSpacing={1} columnSpacing={2}>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Drug Name:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row.dispensedDrugDescription)
              ? "Not Available"
              : row.dispensedDrugDescription}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Qualifier:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row.dispensedQualifier)
              ? "Not Available"
              : row.dispensedQualifier}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Quantity:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row.dispensedQuantity)
              ? "Not Available"
              : row.dispensedQuantity}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Total no.of dispensing requested:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row.dispensedRefills)
              ? "Not Available"
              : row.dispensedRefills}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Notes:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row.dispensedNotes)
              ? "Not Available"
              : row.dispensedNotes}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Substitution:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row.dispensedSubstitution)
              ? "Not Available"
              : row.dispensedSubstitution}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Directions:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row.dispensedDirections)
              ? "Not Available"
              : row.dispensedDirections}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Written Date:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row.dispensedWrittenDate)
              ? "Not Available"
              : row.dispensedWrittenDate}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            LastFill Date:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {[null, ""].includes(row.dispensedLastFilledDate)
              ? "Not Available"
              : row.dispensedLastFilledDate}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

const PharmacyDetails = (props: any) => {
  const { row } = props;
  return (
    <Grid container rowSpacing={1} columnSpacing={2}>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Name:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyName)
            ? "Not Available"
            : row.pharmacyName}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          24 Hours Service:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyTwentyFourHourFlag)
            ? "Not Available"
            : row.pharmacyTwentyFourHourFlag}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Store:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyStoreNumber)
            ? "Not Available"
            : row.pharmacyStoreNumber}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Address:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyAddressLine1)
            ? "Not Available"
            : row.pharmacyAddressLine1 + " " + row.pharmacyAddressLine2}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Land Mark:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyLandMark)
            ? "Not Available"
            : row.pharmacyLandMark}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          City:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyCity)
            ? "Not Available"
            : row.pharmacyCity}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          State:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyState)
            ? "Not Available"
            : row.pharmacyState}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Zip:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyZip)
            ? "Not Available"
            : row.pharmacyZip}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Phone:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyPhoneNumber)
            ? "Not Available"
            : row.pharmacyPhoneNumber}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Fax:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyFaxNumber)
            ? "Not Available"
            : row.pharmacyFaxNumber}
        </Typography>
      </Grid>
    </Grid>
  );
};
